export default "__VITE_ASSET__bo7_ycYz__"